import { Quaternion, Vector3 } from 'three';
import { Tween } from '@verybigthings/vbt-webvr-framework';
class PreparationPickingObjectsClass {
    constructor() { }
    saveObjectState(object) {
        object.userData.prevWorldPosition = object.getWorldPosition(new Vector3()).clone();
        object.userData.prevWorldQuaternion = object.getWorldQuaternion(new Quaternion()).clone();
        object.userData.prevPosition = object.position.clone();
        object.userData.prevQuaternion = object.quaternion.clone();
        object.userData.prevScale = object.scale.clone();
        object.userData.prevParent = object.parent;
    }
    flyObjectToPrevState(object, time = 900) {
        const startPosition = object.position.clone();
        const endPosition = object.userData.prevWorldPosition.clone();
        const startQuaternion = object.quaternion.clone();
        const endQuaternion = object.userData.prevWorldQuaternion.clone();
        new Tween({ alpha: 0 }).to({ alpha: 1 }, time)
            .onStart(() => { })
            // .easing(TWEEN.Easing.Linear.None)
            .onUpdate((alpha) => {
            const newPosition = startPosition.clone().lerp(endPosition.clone(), alpha);
            // @ts-ignore
            object.position.copy(newPosition);
            const newQuaternion = startQuaternion.clone().slerp(endQuaternion.clone(), alpha);
            // @ts-ignore
            object.quaternion.copy(newQuaternion);
        })
            .onComplete(() => {
            object.userData.prevParent.add(object);
            object.position.copy(object.userData.prevPosition);
            object.quaternion.copy(object.userData.prevQuaternion);
            if (object.userData.prevScale)
                object.scale.copy(object.userData.prevScale);
        })
            .start();
    }
}
const PreparationPickingObjects = new PreparationPickingObjectsClass();
export { PreparationPickingObjects };
